import React, { FC, useMemo } from 'react';
import { Segmented } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { guids, paths } from '../../Root/paths';
import isSatisfied from '../../../utils/isSatisfied';
import { iRootState } from '../../../store';

import './ToggleButtons.css';

const mapState = (state: iRootState) => ({
  hasRightsToRoles: isSatisfied({ uid: guids.settings.secTree.roles.root, action: 'Visibility' }, state.securable.data),
  hasRightsToRights: isSatisfied({ uid: guids.settings.secTree.rights.root, action: 'Visibility' }, state.securable.data)
});

type ConnectedProps = ReturnType<typeof mapState>;

const ToggleButtons: FC<ConnectedProps> = ({ hasRightsToRoles, hasRightsToRights }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabs = useMemo(() => {
    const result: Array<{ name: string; url: string }> = [];

    if (hasRightsToRoles) {
      result.push({
        name: 'Роли',
        url: paths.settings.secTree.roles.root
      });
    }

    if (hasRightsToRights) {
      result.push({
        name: 'Доступы',
        url: paths.settings.secTree.rights.root
      });
    }

    return result;
  }, [hasRightsToRoles, hasRightsToRights]);

  const options = useMemo(() => {
    return tabs.map(({ name, url }) => ({ label: name, value: url }));
  }, [tabs]);

  const activeValue = useMemo(() => {
    const match = tabs.find(tab => tab.url === pathname);

    return match?.url ?? (hasRightsToRoles ? paths.settings.secTree.roles.root : paths.settings.secTree.rights.root);
  }, [pathname, hasRightsToRoles, hasRightsToRights]);

  const handleChange = (value: string | number) => {
    history.push(String(value));
  };

  if (tabs.length === 0) {
    return null;
  }

  return (
    <Segmented
      className="sec-tree-toggle-buttons"
      size="large"
      value={activeValue}
      options={options}
      onChange={handleChange}
    />
  );
};

export default connect(mapState)(ToggleButtons);
